import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Badge, Button, Col, MenuItem, NavDropdown, Row } from 'react-bootstrap';
import { FaEllipsisH } from "react-icons/fa";
import { FiCheck, FiX } from 'react-icons/fi';
import { connect } from "react-redux";
import { LinkContainer } from 'react-router-bootstrap';
import { compose, withProps, withStateHandlers } from 'recompose';
import { routes } from '../../../../constants';
import { fullName, excludeManagers } from '../../../../services';
import { pluralise } from '../../../../utils';
import { ControlGroup, ControlOption, Icon, InputFormField, SearchForm, SortableTable, UserAvatar } from '../../../components';

const eventHandler = (handler) => (e) => handler(e.target.name, e.target.value);

const columns = [
  {
    name: 'edit',
    display: () => '',
    className: () => "edit",
  },
  {
    name: 'name',
    display: () => 'Name',
    className: () => "name",
  },
  {
    name: 'operations',
    display: () => '',
    className: () => "operations",
  }
]

const getTeamLabels = (teams, user, teamEditing, userSelected, teamNames, teamIDs) => {
  const userNotAssignedTeam = fp.isEmpty(teamIDs)
  if (!userNotAssignedTeam) {
    const teamName = teamNames.join(',')
    const userInCurrentTeam = fp.contains(fp.get('businessTeam.id')(teamEditing))(teamIDs)
    const teamLable = userInCurrentTeam ?
      <div className='member-team-label'>{userSelected ? `Currently in ${he.decode(teamName)}` : `Will be removed from ${he.decode(teamName)}`}</div> :
      <div className='member-team-label'>{userSelected ? `Will be removed from ${he.decode(teamName)}` : `Currently in ${he.decode(teamName)}`}</div>
    return teamLable
  }
}

export const SetTeam = compose(
  connect(
    (state) => ({
      allTeamMembers: state.business.teamMembers,
      teams: state.business.teams
    }),
    (dispatch) => ({
    })
  ),
  withStateHandlers(
    {
      searchQuery: undefined
    },
    {
      updateSearchQuery: () => (e) => ({
        searchQuery: e.target.value
      })
    }
  ),
  withProps(
    ({ allTeamMembers, toggleTeamMember, toggleTeamManager, toggleNonMemberManager, team, teams, searchQuery, teamEditing }) => ({
      rows: fp.flow(
        excludeManagers,
        fp.filter(
          ({ user }) => fp.contains(fp.toLower(searchQuery))(fp.toLower(fullName(user)))
        ),
        fp.map(
          ({ user, teamNames, teamIDs }) => {
            const userSelected = fp.contains(user.id)(team.members.value)
            const isUserManager = fp.contains(user.id)(team.managers.value)
            const isNonMemberManager = fp.contains(user.id)(team.nonMemberManagers.value)
            const isManager =  isUserManager || isNonMemberManager
            return ({
              edit: <div>
                <ControlGroup
                  id='edit'
                  control='checkbox'
                  type='styled'
                  label={null}>
                  <ControlOption
                    value={user.id}
                    checked={userSelected}
                    label={
                      userSelected ?
                        <FiCheck className='check' /> : null
                    }
                    onChange={() => toggleTeamMember(user.id)} />
                </ControlGroup>
              </div>,
              name: <div className='left text-left'>
                <UserAvatar userName={fullName(user)} avatar={user.avatar} />
                <div className='member-name'>
                  {fullName(user)}
                </div>
                {
                  isManager ?
                    <Badge
                      onClick={() => isUserManager? toggleTeamManager(user.id) : toggleNonMemberManager(user.id)}
                      bsClass='team-manager-badge'
                    >
                      Team manager<FiX />
                    </Badge> :
                    null
                }
                {
                  getTeamLabels(teams, user, teamEditing, userSelected, teamNames, teamIDs)
                }
              </div>,
              operations: <div className='right'>
                {
                  (!isManager) ?
                    <div id='desktop-operation'>
                      <Button
                        onClick={() => userSelected? toggleTeamManager(user.id) : toggleNonMemberManager(user.id)}
                        bsStyle='plain' className='right'
                      >
                        Set as team manager
                      </Button>
                    </div> :
                    null
                }
                {
                  (!isManager) ?
                    <div id='mobile-operation'>
                      <NavDropdown key='dropdown' id='team-operation-dropdown' drop='left' title={<FaEllipsisH />} className='dropdown-list' noCaret={true}>
                        <MenuItem>
                          <Button
                            onClick={() => userSelected? toggleTeamManager(user.id): toggleNonMemberManager(user.id)}
                            bsStyle='plain'
                          >
                            Set as team manager
                          </Button>
                        </MenuItem>
                      </NavDropdown>
                    </div> :
                    null
                }
              </div>
            })
          }
        )
      )(allTeamMembers)
    })
  )
)(
  ({ team, onTeamEdited, searchQuery, updateSearchQuery, rows, teamEditing }) => (
    <div id='set-team'>
      <Row className='no-gutter'>
        <form className='boxed'>
          <Row>
            <Col xs={12}>
              <h2>{teamEditing ? 'Update your team name' : 'Name your new team'}</h2>
            </Col>
          </Row>
          <Row className='no-gutter'>
            <Col xs={12} md={8} className='top-gap-sm' id='name-input'>
              <InputFormField {...{
                id: 'name',
                label: 'Team name',
                onChange: eventHandler(onTeamEdited),
                value: team.name.value,
                validation: team.validation || team.name.validation
              }} />
            </Col>
          </Row>
        </form>
      </Row>

      <Row className='no-gutter flexbox align-center'>
        <Col xs={12} md={8}>
          <h2>
            Select members to add to this team
          </h2>
        </Col>
        <Col xs={12} md={4} className='search-table'>
          <div className='search'>
            <SearchForm
              id='search-desktop'
              label='Search members'
              className='searchDesktop'
              searchQuery={searchQuery}
              onSearchChange={updateSearchQuery} />
          </div>
        </Col>
      </Row>

      <Row className='no-gutter'>
        {
          team.members.validation ?
            <div className='has-error'>
              <span>
                {team.members.validation}
              </span>
            </div> : null
        }
        <form>
          <SortableTable className='members-table' columns={columns} rows={rows} emptyData='There are no members that match your search' />
        </form>
      </Row>
    </div>
  )
);

export const SetTeamFooter = compose(
  connect(
    (state) => ({
    }),
    (dispatch) => ({
    })
  ),
)(
  ({ team, stepBack, stepTo, teamEditing, onTeamSubmitted }) => (
    <div id='set-team-footer' className='flexbox justify-between align-center'>
      <div>
        <Badge className='highlight-badge left'>{fp.upperCase(`${team.members.value.length} ${pluralise('member', team.members.value.length)} selected`)}</Badge>
      </div>
      <div>
        <LinkContainer to={teamEditing ? routes.app.teams.teamMembers(teamEditing.businessTeam.id) : routes.app.teams.root}>
          <Button bsStyle='plain'>Cancel</Button>
        </LinkContainer>
        <Button onClick={onTeamSubmitted}>Review team<Icon className='left-gap' icon='chevron-right-large' /></Button>
      </div>
    </div >
  )
);


// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/set-team.js